module.exports = __webpack_public_path__ + "static/media/icon_iapps_omron.d851e9df.png";